import { render } from "./AvatarListing.vue?vue&type=template&id=52c58746&scoped=true"
import script from "./AvatarListing.vue?vue&type=script&lang=js"
export * from "./AvatarListing.vue?vue&type=script&lang=js"

import "./AvatarListing.vue?vue&type=style&index=0&id=52c58746&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c58746"]])

export default __exports__